import { render } from "./SubmitPost.vue?vue&type=template&id=027988e8"
import script from "./SubmitPost.vue?vue&type=script&lang=js"
export * from "./SubmitPost.vue?vue&type=script&lang=js"

import "./SubmitPost.vue?vue&type=style&index=0&id=027988e8&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__